export default function AboutValues() {
  const values = [
    {
      icon: 'ri-focus-3-line',
      title: 'Precision First',
      description: 'Every workflow is tailored to your operations — no bloated platforms.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Clarity Over Complexity',
      description: 'Systems that are intuitive from day one.',
    },
    {
      icon: 'ri-team-line',
      title: 'People-Centered',
      description: 'Technology should serve your team, not the other way around.',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Speed That Scales',
      description: 'From consultation to deployment — built fast, built to last.',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-3 block">
            Our Values
          </span>
          <h2 className="text-3xl md:text-4xl font-display text-foreground mb-4">
            What drives everything we build.
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div 
              key={index}
              className="group bg-card rounded-2xl p-6 border border-border hover:border-primary/30 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-5 group-hover:bg-primary/20 transition-colors">
                <i className={`${value.icon} text-2xl text-primary`}></i>
              </div>
              <h3 className="font-display text-foreground text-lg font-semibold mb-2">
                {value.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}